import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { COOKIESPREFIX } from '../../config.js';
import React, { useRef } from 'react'
import { Login } from '../../actions/actions';
import NavBar from './components/Navbar.js';
import SideMenu from './components/SideMenu.js';

import LoginPage from './Login.js';
import Home from './Home';
import PartnerDetails from './PartnerDetails.js';
import TshopProduct from './TshopProduct.js';
import PageNotFound from '../PageNotFound.js'

function App(props) {
    const [cookies, setCookie, removeCookie] = useCookies([`${COOKIESPREFIX}_cred`, `${COOKIESPREFIX}_token`]);
    useEffect(() => {
        if(props.token.isLogin&& props.token.usertype!=='merchant'){
            props.dispatch(Login(false));
        }
    }, [props.token])

    if(!props.token.isLogin||props.token.usertype!=='merchant'){
        return(
            <LoginPage/>
        )
    }
    return (
        <div className="relative flex w-full h-full flex-col" style={{overflow:'hidden',maxHeight:'100vh'}}>
            <NavBar/>
            <div className='w-full flex flex-row'  style={{height:'calc(100% - 105px)',overflow:'hidden'}}>
                <SideMenu/>
                <div className='h-full' style={{width:'calc(100% - 290px)'}}>
                    <Routes >
                        <Route path="/" element={<Home />} />
                        <Route path="/partners" element={<PartnerDetails />} />
                        <Route path="/partners/tshop/:id" element={<TshopProduct />} />
                        <Route path="/*" element={<PageNotFound />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(App)

